// extracted by mini-css-extract-plugin
export default {"cursorContainer":"Cursor_cursorContainer__2t+nS","cursor":"Cursor_cursor__ockjH","arrow":"Cursor_arrow__Bf3fj"};